<template>
  <div :class="wrapperClasses">
    <div v-if="title || $slots.title" class="form-group__header">
      <slot name="title">
        <h3 class="form-group__title">{{ title }}</h3>
      </slot>
      <p v-if="description" class="form-group__description">{{ description }}</p>
    </div>

    <div class="form-group__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseFormGroup',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    cols: {
      type: [Number, String],
      default: 1,
      validator: (v) => [1, 2, 3, 4].includes(Number(v))
    },
    gap: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v)
    }
  },
  computed: {
    wrapperClasses() {
      return [
        'form-group',
        `form-group--cols-${this.cols}`,
        `form-group--gap-${this.gap}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../scss/variables' as *;

.form-group {
  width: 100%;
}

.form-group__header {
  margin-bottom: $spacing-4;
}

.form-group__title {
  font-size: $font-size-base;
  font-weight: $font-weight-semibold;
  color: $color-text-primary;
  margin: 0 0 $spacing-1 0;
}

.form-group__description {
  font-size: $font-size-sm;
  color: $color-text-secondary;
  margin: 0;
}

.form-group__content {
  display: grid;
  width: 100%;
}

// Column variants
.form-group--cols-1 .form-group__content {
  grid-template-columns: 1fr;
}

.form-group--cols-2 .form-group__content {
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
  }
}

.form-group--cols-3 .form-group__content {
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
  }
}

.form-group--cols-4 .form-group__content {
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: $breakpoint-xl) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
  }
}

// Gap variants
.form-group--gap-sm .form-group__content {
  gap: $spacing-2;
}

.form-group--gap-md .form-group__content {
  gap: $spacing-4;
}

.form-group--gap-lg .form-group__content {
  gap: $spacing-6;
}
</style>
